import makeAPI from './makeAPI';
import endpoints from './endpoints';

export default makeAPI(endpoints);
